import React, { FunctionComponent } from 'react'
import BidHistoryTable from '../components/BidHistoryTable'
import { legacyLayoutProps } from './constants'

export const BidHistory: FunctionComponent = () => {
  return <BidHistoryTable {...legacyLayoutProps} />
}
